import axios from "axios"

export default {
	getUser(id) {
		return axios.get(`/v1/admin/users/${id}`)
	},
	listUsers(pagination, role, district_id) {
		return axios.post("/v1/admin/users", pagination, { params: { role: role, district_id: district_id } })
	},
	listUsersPrefilled(pagination, role, district_id) {
		return axios.post("/v1/admin/users", pagination, { params: { role: role, district_id: district_id, prefill: true } })
	},
	saveUser(user) {
		return axios.post("/v1/admin/user", user)
	},
	setUserPassword(userID, password) {
		let ctx = {
			user_id: userID,
			password: password,
		}
		return axios.post(`/v1/admin/user_password`, ctx)
	},

	getDistrict(id) {
		return axios.get(`/v1/admin/districts/${id}`)
	},
	listDistricts(pagination) {
		return axios.post("/v1/admin/districts", pagination)
	},
	saveDistrict(district) {
		return axios.post("/v1/admin/district", district)
	},

	getProgram(id) {
		return axios.get(`/v1/admin/programs/${id}`)
	},
	listPrograms(pagination) {
		return axios.post("/v1/admin/programs", pagination)
	},
	saveProgram(program) {
		return axios.post("/v1/admin/program", program)
	},
	getProgramFeedbacks(id) {
		return axios.get(`/v1/admin/programs/${id}/feedbacks`)
	},

	getSchool(id) {
		return axios.get(`/v1/admin/schools/${id}`)
	},
	listSchools(pagination, district_id) {
		return axios.post("/v1/admin/schools", pagination, { params: { district_id: district_id } })
	},
	saveSchool(program) {
		return axios.post("/v1/admin/school", program)
	},

	getSection(id) {
		return axios.get(`/v1/admin/sections/${id}`)
	},
	listSections(pagination) {
		return axios.post("/v1/admin/sections", pagination)
	},
	saveSection(program) {
		return axios.post("/v1/admin/section", program)
	},

	listSubmissions(pagination) {
		return axios.post("/v1/admin/submissions", pagination)
	},

	loadData() {
		return axios.get("/v1/admin/all")
	},

	getDistrictCounts() {
		return axios.get("/v1/admin/counts")
	},

	getSectionCounts(districtID) {
		return axios.get(`/v1/admin/counts/${districtID}`)
	},

	regenerateTeacherCode(districtID) {
		return axios.post(`/v1/admin/district/${districtID}/regen_code/teacher`)
	},

	regeneratePartnerCode(districtID) {
		return axios.post(`/v1/admin/district/${districtID}/regen_code/partner`)
	},

	inviteTeacher(districtID, email) {
		let ctx = {
			email: email,
			role: "TEACHER",
		}

		return axios.post(`/v1/admin/district/${districtID}/invite_teacher`, ctx)
	},

	canDeleteUser(id) {
		return axios.get(`/v1/admin/can_delete/user/${id}`)
	},

	deleteUser(id) {
		return axios.delete(`/v1/admin/user/${id}`)
	},

	canDeleteDistrict(id) {
		return axios.get(`/v1/admin/can_delete/district/${id}`)
	},

	deleteDistrict(id) {
		return axios.delete(`/v1/admin/district/${id}`)
	},

	canDeleteSchool(id) {
		return axios.get(`/v1/admin/can_delete/school/${id}`)
	},

	deleteSchool(id) {
		return axios.delete(`/v1/admin/school/${id}`)
	},

	canDeleteSection(id) {
		return axios.get(`/v1/admin/can_delete/section/${id}`)
	},

	deleteSection(id) {
		return axios.delete(`/v1/admin/section/${id}`)
	},

	canDeleteProgram(id) {
		return axios.get(`/v1/admin/can_delete/program/${id}`)
	},

	deleteProgram(id) {
		return axios.delete(`/v1/admin/program/${id}`)
	},

	getStudentPitches(studentID, sectionID) {
		return axios.get(`/v1/admin/pitches/${studentID}/${sectionID}`)
	},

	getStudentTVRs(studentID, sectionID) {
		return axios.get(`/v1/admin/tvrs/student/${studentID}/${sectionID}`)
	},

	getSectionTVRs(sectionID) {
		return axios.get(`/v1/admin/tvrs/section/${sectionID}`)
	},

	updateSubmission(submission) {
		return axios.post(`/v1/admin/submission`, submission)
	},

	getPitchFeedbacksPrefilled(districtID) {
		return axios.get(`/v1/admin/pitch_feedback/prefilled/${districtID}`)
	},

	getProfilesPrefilled(districtID) {
		return axios.get(`/v1/admin/profile/prefilled/${districtID}`)
	},
	
	getTVRsPrefilled(districtID) {
		return axios.get(`/v1/admin/tvr/prefilled/${districtID}`)
	},
	
	getCanvasesPrefilled(districtID) {
		return axios.get(`/v1/admin/canvas/prefilled/${districtID}`)
	}
}